// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const aliases: any = {
  // Il est impossible d'accéder aux varaibles d'environnement stockées dans les fichiers .env depuis les fichiers de config
  // On est donc obligé de déclarer les URLs de redirection en dur (cf. https://vike.dev/env#config-files)
  '/faq/resiliation-credit-renouvelable': 'https://espace.meia.fr/#/authentification',
}
